import * as React from 'react';

interface ITrastuzumabContentProps {

}

class TrastuzumabContent extends React.PureComponent<ITrastuzumabContentProps> {
    render() {
        return (
            <>
                <h4>
                    Trastuzumab enters clinical practice for metastatic breast cancer
                </h4>
                <p>
                    Trastuzumab enters clinical practice for metastatic breast cancer, following the reporting of trials showing a dramatic increase in survival time with this drug for women whose tumours over-express the HER2 protein (and gene).
                </p>
            </>
        );
    }
}

export default TrastuzumabContent;